var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Watch } from "vue-property-decorator";
import NavMenu from "@/loginApp/template/components/NavMenu.vue";
import FooterNav from "@/common/components/FooterNav.vue";
import InfoBanner from "@/common/components/InfoBanner.vue";
import Notifications from "vue-notification";
import LanguageService from "@/common/services/LanguageService";
import BannerService from "@/common/services/BannerService";
import CookieConsentDialog from '@/template/components/CookieConsentDialog.vue';
import TermsOfUseDialog from '@/template/components/TermsOfUseDialog.vue';
Vue.use(Notifications);
var BounceLoader = require("vue-spinner/dist/vue-spinner.min").BounceLoader;
var LoginApp = /** @class */ (function (_super) {
    __extends(LoginApp, _super);
    function LoginApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bannerService = new BannerService();
        _this.banner = null;
        _this.accptedTermsroute = null;
        _this.allowShowTerms = false; // component may show terms
        return _this;
    }
    LoginApp.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.languageService.initLanguage();
                        _a = this;
                        return [4 /*yield*/, this.bannerService.getBanner()];
                    case 1:
                        _a.banner = _b.sent();
                        this.cookiePolicy.setPageView(this.matomoLoginAppPathPrefix);
                        this.$root.$on("showTerms", function () {
                            _this.allowShowTerms = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginApp.prototype.onChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.bannerService.getBanner()];
                    case 1:
                        _a.banner = _b.sent();
                        // Cookie policy is enforced on every navigation because the policy may change outside the 
                        // current app (Privacy policy page is its own app when opened in a new tab and it cannot
                        // disable the google analytics of the current tab).
                        // If this becomes an issue, consider approaches such as the BroadcastChannel API to 
                        // communicate between apps.
                        this.cookiePolicy.setPageView(this.matomoLoginAppPathPrefix + this.$route.path);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LoginApp.prototype, "languageService", {
        get: function () {
            return new LanguageService(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoginApp.prototype, "showBanner", {
        get: function () {
            var routeName = this.$router.currentRoute.name;
            return routeName !== "instructions" && routeName !== "accessibility-statement" && routeName !== "privacy-policy";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoginApp.prototype, "isInPrintMode", {
        get: function () {
            var hideNav = this.$route.meta.hideNav;
            return hideNav != null && hideNav === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoginApp.prototype, "isConsented", {
        get: function () {
            var ret = this.$store.state.vuexPageModule.isConsented;
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoginApp.prototype, "cookiePolicy", {
        get: function () {
            return this.$store.state.vuexPageModule.cookiePolicy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoginApp.prototype, "matomoLoginAppPathPrefix", {
        get: function () {
            var tmp = this.$store.state.vuexPageModule.configuration;
            return tmp.matomoLoginAppPrefix;
        },
        enumerable: false,
        configurable: true
    });
    LoginApp.prototype.onCloseTermsModal = function (termsRead) {
        this.allowShowTerms = false;
        this.$root.$emit('registerTermsRead', termsRead);
    };
    __decorate([
        Watch("$route.path"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LoginApp.prototype, "onChange", null);
    LoginApp = __decorate([
        Component({
            name: "LoginApp",
            components: {
                NavMenu: NavMenu,
                InfoBanner: InfoBanner,
                BounceLoader: BounceLoader,
                FooterNav: FooterNav,
                CookieConsentDialog: CookieConsentDialog,
                TermsOfUseDialog: TermsOfUseDialog
            }
        })
    ], LoginApp);
    return LoginApp;
}(Vue));
export default LoginApp;
